/* format money function */

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || "{{amount}}";

  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split(".");
    let dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    let centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  let value = "";
  const matchResult = formatString.match(placeholderRegex);
  const placeholder = matchResult ? matchResult[1] : "amount";

  switch (placeholder) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

window.formatMoney = formatMoney;

/* Global Utilities */
window.Kinderly = window.Kinderly || {};

window.Kinderly.safeForEach = function (collection, callback) {
  if (!collection || !collection.forEach) return;
  try {
    collection.forEach(callback);
  } catch (error) {
    console.warn('safeForEach error:', error);
  }
};

window.Kinderly.debounce = function (fn, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
};

window.Kinderly.initSection = function (sectionSelector, initFn) {
  if (!sectionSelector) return;

  let elements = [];
  if (typeof sectionSelector === 'string') {
    try {
      elements = document.querySelectorAll(sectionSelector);
    } catch (e) {
      console.warn('Kinderly.initSection: Invalid selector', sectionSelector);
    }
  } else if (sectionSelector.nodeType) {
    elements = [sectionSelector];
  } else if (sectionSelector.length !== undefined) {
    elements = sectionSelector;
  }

  Array.from(elements).forEach(el => initFn(el));

  document.addEventListener('shopify:section:load', (event) => {
    let section = null;
    if (typeof sectionSelector === 'string') {
      section = event.target.querySelector(sectionSelector) || (event.target.classList?.contains(sectionSelector.replace('.', '')) ? event.target : null);
    } else if (event.target === sectionSelector || event.target.contains(sectionSelector)) {
      section = sectionSelector;
    }
    if (section) initFn(section);
  });
};

/* Central Re-init function for Shopify Design Mode */
window.Kinderly.reinitAll = function (container = document) {
  if (!container) return;

  if (typeof initFAQSections === 'function') {
    initFAQSections();
  }

  if (typeof initLogoList === 'function') {
    initLogoList();
  }

  if (typeof window.initSectionAnimations === 'function') {
    window.initSectionAnimations(container);
  } else if (typeof window.refreshAllAnimations === 'function') {
    window.refreshAllAnimations();
  }

  if (typeof ProductCardSwatches === 'function') {
    new ProductCardSwatches();
  }

  if (typeof Slideshow === 'function') {
    container.querySelectorAll('.slideshow-section').forEach(el => {
      new Slideshow(el).initialize();
    });
  }

  if (typeof (FeaturedCollectionTabsSection) === 'function') {
    container.querySelectorAll('.featured-collection-section').forEach(el => {
      if (el.querySelector('.tabs-wrapper')) {
        new FeaturedCollectionTabsSection(el);
      } else if (el.querySelector('[id^="product-recommendations-"]')) {
        new RelatedProductsSection(el);
      }
    });
  }

  if (typeof ScrollTrigger !== 'undefined') {
    if (!window._debouncedRefresh) {
      window._debouncedRefresh = Kinderly.debounce(() => ScrollTrigger.refresh(), 200);
    }
    window._debouncedRefresh();
  }
};

window.Kinderly.Swiper = {
  thumbSelectors: [
    '[data-swiper-thumb]',
    '.product-recommendation-star-thumb',
    '.featured-collection-star-thumb',
    '.testimonial-star-thumb',
    '.image-card-star-thumb',
    '.multicolumn-star-thumb',
    '.gallery-star-thumb',
    '.highlight-testimonial-star-thumb',
    '.collection-list-slideshow-star-thumb',
    '.blog-post-star-thumb',
    '.logo-list-star-thumb'
  ],

  findThumbElement: function (container) {
    for (let selector of this.thumbSelectors) {
      const el = container.querySelector(selector);
      if (el) return el;
    }
    return null;
  },

  updateThumbPosition: function (swiper, container) {
    const star = this.findThumbElement(container);
    const fill = container.querySelector('.swiper-pagination-progressbar-fill');
    if (!star && !fill) return;

    const slides = container.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
    const total = slides.length || 1;
    const currentIndex = swiper.realIndex !== undefined ? swiper.realIndex : (swiper.activeIndex || 0);
    const position = (currentIndex + 1) / total;

    requestAnimationFrame(() => {
      if (star) star.style.left = `${position * 100}%`;
      if (fill) {
        fill.style.transform = `scaleX(${position})`;
        fill.style.webkitTransform = `scaleX(${position})`;
      }
    });
  },

  getCommonThumbOptions: function (container) {
    const _this = this;
    return {
      on: {
        init: (swiper) => _this.updateThumbPosition(swiper, container),
        slideChange: (swiper) => _this.updateThumbPosition(swiper, container),
        setTransition: (swiper, duration) => {
          const star = _this.findThumbElement(container);
          if (star) star.style.transitionDuration = `${duration}ms`;
        }
      }
    };
  },

  init: function (elOrSelector, options) {
    if (typeof Swiper === 'undefined' || !elOrSelector) return;

    let containers = [];
    if (typeof elOrSelector === 'string') {
      try {
        containers = document.querySelectorAll(elOrSelector);
      } catch (e) {
        console.warn('Kinderly.Swiper.init: Invalid selector', elOrSelector);
        return;
      }
    } else if (elOrSelector.nodeType) {
      containers = [elOrSelector];
    } else if (typeof elOrSelector.forEach === 'function' || elOrSelector.length !== undefined) {
      containers = elOrSelector;
    } else {
      containers = [elOrSelector];
    }

    const items = Array.from(containers);
    items.forEach(container => {
      if (!container || !container.nodeType) return;

      if (container.swiper) {
        try {
          container.swiper.destroy(true, true);
        } catch (e) { }
        container.swiper = null;
      }
      const finalOptions = {
        ...options,
        ...this.getCommonThumbOptions(container)
      };

      const doInit = () => {
        if (container.swiper) return;
        try {
          container.swiper = new Swiper(container, finalOptions);
          if (typeof options.onInit === 'function') {
            options.onInit(container.swiper);
          }
        } catch (e) {
          console.warn('Swiper initialization failed:', e);
        }
      };

      const scheduleInit = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            doInit();
          });
        });
      };

      if (options.immediate) {
        scheduleInit();
      } else {
        const observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            scheduleInit();
            observer.disconnect();
          }
        }, { rootMargin: '200px' });
        observer.observe(container);
      }
    });
  }
};

window.Kinderly.initNewsletter = function (wrapperId, errorMsg) {
  const wrapper = document.getElementById(wrapperId);
  if (!wrapper) return;

  const form = wrapper.querySelector('form');
  const input = wrapper.querySelector('input[type="email"]');
  const errorEl = wrapper.querySelector('.newsletter-validation-error');
  const msgEl = wrapper.querySelector('.newsletter-validation-message');

  if (!form || !input || !errorEl) return;

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  }

  function showError(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    input.classList.add('newsletter-input--error');
    input.setAttribute('aria-invalid', 'true');
    errorEl.classList.add('is-visible');
    if (msgEl) msgEl.textContent = errorMsg;
    input.focus();
    input.style.animation = 'newsletter-shake 0.5s ease-in-out';
    setTimeout(() => {
      input.style.animation = '';
    }, 500);

    return false;
  }

  function clearError() {
    input.classList.remove('newsletter-input--error');
    input.setAttribute('aria-invalid', 'false');
    errorEl.classList.remove('is-visible');
    if (msgEl) msgEl.textContent = '';
  }

  form.addEventListener('submit', function (e) {
    const val = input.value.trim();
    if (val === '' || !isValidEmail(val)) {
      showError(e);
      return false;
    }
  }, true);

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      const val = input.value.trim();
      if (val === '' || !isValidEmail(val)) {
        showError(e);
      }
    }
  });

  input.addEventListener('input', function () {
    if (input.classList.contains('newsletter-input--error')) {
      if (isValidEmail(input.value.trim())) {
        clearError();
      }
    }
  });

  input.addEventListener('blur', function () {
    const val = input.value.trim();
    if (val !== '' && !isValidEmail(val)) {
      showError();
    }
  });
};

/* Global Theme Initializations */
const initGlobalTheme = () => {
  const btn = document.querySelector('.back-to-top');
  if (btn) {
    btn.classList.add('hidden');
    window.addEventListener('scroll', Kinderly.debounce(() => {
      if (window.scrollY > 300) {
        btn.classList.remove('hidden');
      } else {
        btn.classList.add('hidden');
      }
    }, 100), { passive: true });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.lenis) {
        window.lenis.scrollTo(0, { duration: 1.5 });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  initFAQSections();

  if (typeof initLogoList === 'function') {
    initLogoList();
  }

};

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initGlobalTheme());
} else {
  setTimeout(initGlobalTheme, 600);
}

function initFAQSections() {
  const FAQSections = document.querySelectorAll('.faq-section[data-section-id]');

  FAQSections.forEach(FAQSection => {
    const FAQItems = FAQSection.querySelectorAll('.faq-item');
    const allowMultiple = FAQSection.getAttribute('data-allow-multiple') === 'true';

    FAQItems.forEach(item => {
      const toggle = item.querySelector('[data-faq-toggle]');
      const content = item.querySelector('[data-faq-content]');

      if (!toggle || !content) return;

      toggle.addEventListener('click', function () {
        toggleFAQ(item, FAQItems, allowMultiple);
      });

      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleFAQ(item, FAQItems, allowMultiple);
        }
      });
    });
  });
}

function toggleFAQ(item, allItems, allowMultiple) {
  const isActive = item.classList.contains('active');
  const toggle = item.querySelector('[data-faq-toggle]');

  if (!allowMultiple) {
    allItems.forEach(otherItem => {
      if (otherItem !== item && otherItem.classList.contains('active')) {
        otherItem.classList.remove('active');
        const otherToggle = otherItem.querySelector('[data-faq-toggle]');
        if (otherToggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  if (isActive) {
    item.classList.remove('active');
    toggle.setAttribute('aria-expanded', 'false');
  } else {
    item.classList.add('active');
    toggle.setAttribute('aria-expanded', 'true');
  }
}

class LogoListSection {
  constructor(container) {
    this.container = container;
    this.slideshows = container.querySelectorAll('.logo-list-slideshow');
    this.isDesktop = window.innerWidth >= 990;
    this.isMobile = window.innerWidth < 750;

    if (this.slideshows.length && typeof Swiper !== 'undefined') {
      this.init();
      this.bindEvents();
    }
  }

  init() {
    const shouldInit = this.shouldInitializeSlideshow();

    this.slideshows.forEach(slideshow => {
      if (shouldInit && !slideshow.swiper) {
        this.createSwiper(slideshow);
      }
      else if (!shouldInit && slideshow.swiper) {
        this.destroySwiper(slideshow);
      }
    });
  }

  shouldInitializeSlideshow() {
    const desktopView = this.container.dataset.desktopView;
    const mobileView = this.container.dataset.mobileView;

    if (this.isDesktop) return desktopView === 'slideshow';
    if (this.isMobile) return mobileView === 'slideshow';
    return desktopView === 'slideshow';
  }

  createSwiper(slideshow) {
    const desktopItems = parseInt(this.container.dataset.desktopItems) || 6;
    const mobileItems = parseInt(this.container.dataset.mobileItems) || 2;
    const autoplay = slideshow.dataset.autoplay === 'true';
    const speed = (parseInt(slideshow.dataset.speed) || 5) * 1000;

    Kinderly.Swiper.init(slideshow, {
      slidesPerView: mobileItems,
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: slideshow.querySelector('.logo-list-next'),
        prevEl: slideshow.querySelector('.logo-list-prev'),
      },
      pagination: {
        el: slideshow.querySelector('.logo-list-pagination'),
        type: "progressbar",
      },
      autoplay: autoplay ? {
        delay: speed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      breakpoints: {
        750: {
          slidesPerView: Math.min(desktopItems - 2, 4),
          spaceBetween: 24
        },
        990: {
          slidesPerView: desktopItems,
          spaceBetween: 24
        }
      }
    });

    slideshow.classList.add('swiper-initialized');
  }

  destroySwiper(slideshow) {
    if (slideshow.swiper) {
      slideshow.swiper.destroy(true, true);
      slideshow.swiper = null;
      slideshow.classList.remove('swiper-initialized');
    }
  }

  bindEvents() {
    let resizeTimer;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const wasDesktop = this.isDesktop;
        const wasMobile = this.isMobile;

        this.isDesktop = window.innerWidth >= 990;
        this.isMobile = window.innerWidth < 750;

        if (wasDesktop !== this.isDesktop || wasMobile !== this.isMobile) {
          this.init();
        } else {
          this.slideshows.forEach(s => s.swiper?.update());
        }
      }, 200);
    });
  }
}

function initLogoList(retryCount = 0) {
  if (typeof Swiper === 'undefined') {
    if (retryCount < 10) {
      setTimeout(() => initLogoList(retryCount + 1), 200);
    }
    return;
  }

  document.querySelectorAll('.logo-list').forEach(section => {
    if (!section.logoListInstance) {
      section.logoListInstance = new LogoListSection(section);
    }
  });
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    document.body.classList.remove('no-scroll', 'drawer-open', 'menu-open', 'modal-open', 'quickview-open');
    if (window.Kinderly && typeof window.Kinderly.reinitAll === 'function') {
      window.Kinderly.reinitAll(event.target);
    }
    initLogoList();
    event.target.dispatchEvent(new CustomEvent('section:reinit', { bubbles: true }));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    document.body.classList.remove('no-scroll', 'drawer-open', 'menu-open', 'modal-open', 'quickview-open');
  });

  document.addEventListener('shopify:block:select', function (event) {
    const block = event.target;

    if (block.classList.contains('swiper-slide')) {
      const swiperContainer = block.closest('.swiper, .slideshow, .swiper-container');
      if (swiperContainer && swiperContainer.swiper) {
        const swiper = swiperContainer.swiper;
        swiper.autoplay?.stop();

        const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
        const index = slides.indexOf(block);

        if (index !== -1) {
          if (typeof swiper.slideToLoop === 'function' && swiper.params.loop) {
            swiper.slideToLoop(index);
          } else {
            swiper.slideTo(index);
          }
        }
      }
    } else {

      if (typeof block.scrollIntoView === 'function') {
        const rect = block.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (!isVisible) {
          block.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }

    const logoSection = block.closest('.logo-list');
    if (logoSection && logoSection.logoListInstance) {
      const slide = block.closest('.swiper-slide');
      if (slide) {
        logoSection.logoListInstance.slideshows.forEach(slideshow => {
          if (slideshow.swiper) {
            const index = Array.from(slideshow.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')).indexOf(slide);
            if (index !== -1) {
              if (slideshow.swiper.params.loop && typeof slideshow.swiper.slideToLoop === 'function') {
                slideshow.swiper.slideToLoop(index);
              } else {
                slideshow.swiper.slideTo(index);
              }
              slideshow.swiper.autoplay?.stop();
            }
          }
        });
      }
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    const block = event.target;

    if (block.classList.contains('swiper-slide')) {
      const swiperContainer = block.closest('.swiper, .slideshow, .swiper-container');
      if (swiperContainer && swiperContainer.swiper) {
        swiperContainer.swiper.autoplay?.start();
      }
    }

    const logoSection = block.closest('.logo-list');
    if (logoSection && logoSection.logoListInstance) {
      logoSection.logoListInstance.slideshows.forEach(slideshow => {
        if (slideshow.swiper) {
          slideshow.swiper.autoplay?.start();
        }
      });
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.logo-list').forEach(section => {
      if (section.logoListInstance) {
        section.logoListInstance.slideshows.forEach(s => section.logoListInstance.destroySwiper(s));
        section.logoListInstance = null;
      }
    });

    event.target.querySelectorAll('.swiper, .slideshow, .swiper-container').forEach(container => {
      if (container.swiper && typeof container.swiper.destroy === 'function') {
        container.swiper.destroy(true, true);
        container.swiper = null;
      }
    });
  });
}



/* Password Page Popup js start */

class PasswordPopup {
  constructor() {
    this.popup = document.querySelector('.password-popup-content');
    this.init();
  }

  init() {
    if (this.popup) {
      document.querySelectorAll('.password-link-content').forEach(element => {
        element.addEventListener('click', () => this.openPopup());
      });

      document.querySelectorAll('.password-popup-close').forEach(element => {
        element.addEventListener('click', () => this.closePopup());
      });

      window.addEventListener('click', (event) => this.handleOutsideClick(event));
      this.handleKeyboardEvents();
    }
  }

  openPopup() {
    this.popup.style.display = 'flex';
  }

  closePopup() {
    this.popup.style.display = 'none';
  }

  handleOutsideClick(event) {
    if (event.target === this.popup) {
      this.closePopup();
    }
  }

  handleKeyboardEvents() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.popup.style.display === 'flex') {
        this.closePopup();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PasswordPopup();
});

/* Password Page Popup js end */

/* testimonials slider js start */

(function () {

  function initTestimonialSection(container) {
    if (!container) return;
    const sliders = container.classList?.contains('testimonials-slider') ? [container] : container.querySelectorAll(".testimonials-slider");

    sliders.forEach(slider => {
      const desktopSlides = slider.dataset.desktopSlides || 3;
      const mobileSlides = slider.dataset.mobileSlides || 1;
      const autoplay = slider.dataset.autoplay === "true";

      Kinderly.Swiper.init(slider, {
        slidesPerView: desktopSlides,
        spaceBetween: 40,
        loop: true,
        autoplay: autoplay ? { delay: 3000, disableOnInteraction: false } : false,
        navigation: {
          nextEl: slider.querySelector(".testimonial-next"),
          prevEl: slider.querySelector(".testimonial-prev"),
        },
        pagination: {
          el: slider.querySelector(".testimonial-pagination"),
          type: "progressbar",
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          450: { slidesPerView: mobileSlides },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: desktopSlides },
        }
      });
    });
  }

  function initAllTestimonialSections() {
    document.querySelectorAll(".testimonials-section").forEach(initTestimonialSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllTestimonialSections);
  } else {
    initAllTestimonialSections();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      event.target.querySelectorAll(".testimonials-section").forEach(initTestimonialSection);
    });
  }

})();

/* testimonials slider js end */

/* textarea js start */

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('mousedown', (e) => {
    if (e.target.tagName === 'TEXTAREA') {
      const textarea = e.target;

      setTimeout(() => {
        if (document.activeElement === textarea) {
          textarea.setSelectionRange(0, 0);
        }
      }, 0);
    }
  });

  document.addEventListener('focus', (e) => {
    if (e.target.tagName === 'TEXTAREA') {
      setTimeout(() => {
        e.target.setSelectionRange(0, 0);
      }, 0);
    }
  }, true);
});

/* textarea js end */

/* Image card js start  */

(function () {

  function initImageCardSection(container) {
    if (!container) return;
    const slideshows = container.classList?.contains('image-card-slideshow') ? [container] : container.querySelectorAll('.image-card-slideshow');

    slideshows.forEach(slideshow => {
      const desktopSlides = parseInt(slideshow.dataset.desktopSlides) || 3;
      const mobileSlides = parseInt(slideshow.dataset.mobileSlides) || 1;
      const autoplay = slideshow.dataset.autoplay === 'true';
      const speed = parseInt(slideshow.dataset.speed) || 3000;

      Kinderly.Swiper.init(slideshow, {
        slidesPerView: mobileSlides,
        spaceBetween: 20,
        loop: true,
        autoplay: autoplay ? { delay: speed, disableOnInteraction: false } : false,
        navigation: {
          nextEl: slideshow.querySelector('.image-card-slideshow-next'),
          prevEl: slideshow.querySelector('.image-card-slideshow-prev'),
        },
        pagination: {
          el: slideshow.querySelector(".image-card-pagination"),
          type: "progressbar",
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          450: { slidesPerView: mobileSlides },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: desktopSlides }
        }
      });
    });
  }

  function initAllImageCardSections() {
    document.querySelectorAll('.image-card-section').forEach(initImageCardSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllImageCardSections);
  } else {
    initAllImageCardSections();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.image-card-section').forEach(initImageCardSection);
    });
  }

})();

/* Image card js end */

/* Country selector js start */

document.addEventListener('DOMContentLoaded', () => {
  class CountryDropdown {
    constructor(dropdown) {
      this.dropdown = dropdown;
      this.button = dropdown.querySelector('.country-dropdown');
      this.list = dropdown.querySelector('.country-list');
      this.input = dropdown.querySelector('input[name="country_code"]');

      if (this.button && this.list && this.input) {
        this.button.addEventListener('click', this.toggleDropdown.bind(this));
        this.list.addEventListener('click', this.onItemClick.bind(this));
        this.button.addEventListener('keydown', this.onContainerKeyUp.bind(this));
        this.list.addEventListener('keydown', this.onContainerKeyUp.bind(this));
        document.addEventListener('click', this.onDocumentClick.bind(this));
      }
    }

    toggleDropdown() {
      const expanded = this.button.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        this.button.setAttribute('aria-expanded', 'false');
        this.list.setAttribute('hidden', '');
      } else {
        this.closeOtherDropdowns();
        this.button.setAttribute('aria-expanded', 'true');
        this.list.removeAttribute('hidden');
      }
    }

    closeOtherDropdowns() {
      const allDropdowns = document.querySelectorAll('.dropdown');
      allDropdowns.forEach(otherDropdown => {
        if (otherDropdown !== this.dropdown) {
          const otherList = otherDropdown.querySelector('.country-list');
          const otherButton = otherDropdown.querySelector('.country-dropdown');
          if (otherList && otherButton) {
            otherList.setAttribute('hidden', '');
            otherButton.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }

    onItemClick(event) {
      const countryItem = event.target.closest('.country-item');
      if (countryItem) {
        const selectedValue = countryItem.dataset.value;
        this.input.value = selectedValue;
        const countryText = countryItem.innerHTML;
        this.updateAllDropdowns(countryText, selectedValue);
        this.closeDropdown();

        const form = this.dropdown.closest('form');
        if (form) {
          form.submit();
        }
      }
    }

    onContainerKeyUp(event) {
      const key = (event.code || event.key || '').toUpperCase();
      if (key === 'ESCAPE' || key === 'ESC') {
        this.closeDropdown();
      }
    }

    onDocumentClick(event) {
      if (!this.dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    }

    closeDropdown() {
      this.list.setAttribute('hidden', '');
      this.button.setAttribute('aria-expanded', 'false');
    }

    updateAllDropdowns(countryText, selectedValue) {
      const allDropdowns = document.querySelectorAll('.dropdown');
      allDropdowns.forEach(dropdown => {
        const button = dropdown.querySelector('.country-dropdown');
        const input = dropdown.querySelector('input[name="country_code"]');
        const selectedCountrySpan = dropdown.querySelector('#selected-country');

        if (button && input && selectedCountrySpan) {
          selectedCountrySpan.innerHTML = countryText;
          input.value = selectedValue;
        }
      });
    }
  }

  const dropdowns = document.querySelectorAll('.dropdown');
  dropdowns.forEach(dropdown => {
    if (dropdown) {
      new CountryDropdown(dropdown);
    }
  });
});

/* Country selector js end */

/* Language selector js start */

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: null,
      button: null,
      panel: null
    };
  }

  connectedCallback() {
    this.elements.input = this.querySelector('input[name="language_code"]');
    this.elements.button = this.querySelector('.language_form_button');
    this.elements.panel = this.querySelector('#LanguageList');

    if (this.elements.button && this.elements.panel && this.elements.input) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
  }

  hidePanel() {
    if (this.elements.button && this.elements.panel) {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      this.hidePanel();
      if (this.elements.button) this.elements.button.focus();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (this.elements.input) {
      this.elements.input.value = event.currentTarget.dataset.value;
    }
    if (form) form.submit();
  }

  openSelector() {
    if (this.elements.button && this.elements.panel) {
      this.elements.button.focus();
      const isHidden = this.elements.panel.hasAttribute('hidden');

      if (isHidden) {
        this.elements.panel.removeAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', 'true');
      } else {
        this.elements.panel.setAttribute('hidden', '');
        this.elements.button.setAttribute('aria-expanded', 'false');
      }
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  customElements.define('localization-form', LocalizationForm);
});

/* Language selector js end */

/* multi-column js start */

(function () {

  function destroyMultiColumnSwipers(container) {
    if (!container) return;
    container.querySelectorAll('.multicolumn-slideshow').forEach(slideshow => {
      if (slideshow.swiper) slideshow.swiper.destroy(true, true);
    });
  }

  function updateMulticolumnThumb(swiper, slideshow) {
    const star = slideshow.querySelector('.multicolumn-star-thumb');
    const fill = slideshow.querySelector('.swiper-pagination-progressbar-fill');
    const slides = slideshow.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
    const total = slides.length || 1;
    const position = ((swiper.realIndex || swiper.activeIndex || 0) + 1) / total;
    if (star) star.style.left = `${position * 100}%`;
    if (fill) {
      fill.style.transform = `scaleX(${position})`;
      fill.style.webkitTransform = `scaleX(${position})`;
    }
  }

  function initMultiColumnSection(container) {
    if (!container) return;
    const slideshows = container.classList?.contains('multicolumn-slideshow') ? [container] : container.querySelectorAll('.multicolumn-slideshow');

    slideshows.forEach(slideshow => {
      const desktopView = slideshow.dataset.desktopView || 'grid';
      const mobileSlideshow = slideshow.dataset.mobileSlideshow === 'true';
      const desktopSlides = parseInt(slideshow.dataset.desktopSlides) || 3;
      const mobileSlides = parseInt(slideshow.dataset.mobileSlides) || 1;
      const autoplay = slideshow.dataset.autoplay === 'true';
      const speed = parseInt(slideshow.dataset.speed) || 3000;
      const enableLoop = slideshow.dataset.enableLoop === 'true';

      const isMobile = window.innerWidth < 768;
      const shouldSlide = (isMobile && mobileSlideshow) || (!isMobile && desktopView === 'slideshow');

      if (slideshow.swiper) {
        if (!shouldSlide) { slideshow.swiper.destroy(true, true); return; }
        slideshow.swiper.update(); return;
      }

      if (!shouldSlide) return;

      const runPostInit = (swiper) => {
        swiper.on('init', (s) => updateMulticolumnThumb(s, slideshow));
        swiper.on('slideChange', (s) => updateMulticolumnThumb(s, slideshow));
        swiper.on('setTransition', (s, duration) => {
          const star = slideshow.querySelector('.multicolumn-star-thumb');
          if (star) star.style.transitionDuration = `${duration}ms`;
        });
        updateMulticolumnThumb(swiper, slideshow);
      };

      Kinderly.Swiper.init(slideshow, {
        slidesPerView: mobileSlides,
        spaceBetween: 15,
        loop: enableLoop,
        autoplay: autoplay ? { delay: speed, disableOnInteraction: false } : false,
        navigation: {
          nextEl: slideshow.querySelector('.multicolumn-slideshow-next'),
          prevEl: slideshow.querySelector('.multicolumn-slideshow-prev'),
        },
        pagination: {
          el: slideshow.querySelector('.multicolumn-pagination'),
          type: 'progressbar',
        },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 15 },
          450: { slidesPerView: mobileSlides, spaceBetween: 15 },
          768: { slidesPerView: desktopSlides, spaceBetween: 20, enabled: desktopView === 'slideshow' },
          1024: { slidesPerView: desktopSlides, spaceBetween: 20, enabled: desktopView === 'slideshow' },
        },
        onInit: runPostInit
      });
    });
  }

  function reinitMultiColumnSection(container) {
    destroyMultiColumnSwipers(container);
    initMultiColumnSection(container);
  }

  function initAllMultiColumnSections() {
    document.querySelectorAll('.multicolumn-section').forEach(section => {
      requestAnimationFrame(() => initMultiColumnSection(section));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMultiColumnSections);
  } else {
    initAllMultiColumnSections();
  }

  window.addEventListener('resize', Kinderly.debounce(() => {
    document.querySelectorAll('.multicolumn-section').forEach(reinitMultiColumnSection);
  }, 250));

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.multicolumn-section').forEach(section => {
        destroyMultiColumnSwipers(section);
        initMultiColumnSection(section);
      });
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.multicolumn-section').forEach(destroyMultiColumnSwipers);
    });
  }

})();

/* multi-column js end */

/* gallery slideshow js start */

(function () {

  function initGallerySection(container) {
    if (!container) return;
    const slideshows = container.classList?.contains('gallery-slideshow') ? [container] : container.querySelectorAll('.gallery-slideshow');

    slideshows.forEach(slideshow => {
      const desktopSlides = parseInt(slideshow.dataset.desktopSlides) || 3;
      const mobileSlides = parseInt(slideshow.dataset.mobileSlides) || 1;
      const autoplay = slideshow.dataset.autoplay === 'true';
      const speed = parseInt(slideshow.dataset.speed) || 3000;

      Kinderly.Swiper.init(slideshow, {
        slidesPerView: mobileSlides,
        spaceBetween: 16,
        loop: true,
        autoplay: autoplay ? { delay: speed, disableOnInteraction: false } : false,
        navigation: {
          nextEl: slideshow.querySelector('.gallery-slideshow-next'),
          prevEl: slideshow.querySelector('.gallery-slideshow-prev'),
        },
        pagination: {
          el: slideshow.querySelector(".gallery-pagination"),
          type: "progressbar",
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          450: { slidesPerView: mobileSlides },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: desktopSlides }
        }
      });
    });
  }

  function initAllGallerySections() {
    document.querySelectorAll('.gallery-slideshow-section').forEach(section => {
      requestAnimationFrame(() => initGallerySection(section));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGallerySections);
  } else {
    initAllGallerySections();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.gallery-slideshow-section').forEach(initGallerySection);
    });
  }

})();

/* gallery slideshow js end */

/* rich text js start */

(function () {
  function initScrollAnimations() {
    const scrollElements = document.querySelectorAll('.scroll-fade-in');
    const imageElements = document.querySelectorAll('.scroll-image-reveal');

    const observerOptions = {
      root: null,
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          if (element.classList.contains('is-visible')) {
            observer.unobserve(element);
            return;
          }

          const delay = parseInt(element.getAttribute('data-scroll-delay')) || 0;

          if (delay > 0) {
            setTimeout(() => {
              element.classList.add('is-visible');
            }, delay);
          } else {
            element.classList.add('is-visible');
          }

          observer.unobserve(element);
        }
      });
    }, observerOptions);

    scrollElements.forEach(el => observer.observe(el));
    imageElements.forEach(el => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initScrollAnimations);
    document.addEventListener('shopify:section:reorder', initScrollAnimations);
  }
})();

/* rich text js end */

/* collection list js start */

(function () {

  class CollectionListSlider {
    constructor(container) {
      this.container = container;
      this.wrapper = container.querySelector(".collection-list-wrapper");
      this.slideshow = container.querySelector(".collection-list-slideshow");
      this.swiper = null;
      this.isMobile = window.innerWidth < 768;

      if (this.slideshow && typeof Swiper !== "undefined") {
        this.init();
        this.bindEvents();
      }
    }

    init() {
      const shouldShowSlideshow = this.shouldShowSlideshow();
      if (shouldShowSlideshow) {
        this.createSwiper();
      } else {
        this.destroy();
      }
    }

    shouldShowSlideshow() {
      if (!this.wrapper) return false;
      const desktopView = this.wrapper.dataset.desktopView;
      const mobileSlideshow = this.wrapper.dataset.mobileSlideshow === "true";

      if (this.isMobile) {
        return mobileSlideshow;
      }
      return desktopView === "slideshow";
    }

    createSwiper() {
      if (this.swiper || !this.slideshow) return;

      const desktopSlides = parseInt(this.slideshow.dataset.desktopSlides) || 4;
      const mobileSlides = parseInt(this.slideshow.dataset.mobileSlides) || 1;
      const autoplay = this.slideshow.dataset.autoplay === "true";
      const speed = parseInt(this.slideshow.dataset.speed) || 3000;

      Kinderly.Swiper.init(this.slideshow, {
        slidesPerView: this.isMobile ? mobileSlides : desktopSlides,
        spaceBetween: 20,
        loop: false,
        autoplay: autoplay ? { delay: speed, disableOnInteraction: false } : false,
        navigation: {
          nextEl: this.container.querySelector(".collection-list-slideshow-next"),
          prevEl: this.container.querySelector(".collection-list-slideshow-prev"),
        },
        pagination: {
          el: this.container.querySelector(".collection-list-slideshow-pagination-progressbar"),
          type: "progressbar",
        },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 15 },
          450: { slidesPerView: mobileSlides, spaceBetween: 15 },
          768: { slidesPerView: desktopSlides, spaceBetween: 20 }
        },
        onInit: (swiper) => { this.swiper = swiper; }
      });
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    bindEvents() {
      window.addEventListener("resize", Kinderly.debounce(() => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 768;

        if (wasMobile !== this.isMobile) {
          this.init();
        }
      }, 200));
    }
  }

  function initTestimonialSliders(container) {
    const swiperElement = container.querySelector(".testimonialSlider");
    if (!swiperElement) return;

    requestAnimationFrame(() => {
      Kinderly.Swiper.init(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: { delay: 3000, disableOnInteraction: false },
        navigation: {
          nextEl: container.querySelector(".testimonial-slider-next"),
          prevEl: container.querySelector(".testimonial-slider-prev"),
        },
        pagination: {
          el: container.querySelector(".testimonial-pagination"),
          type: "progressbar",
        }
      });
    });
  }

  window.CollectionListSliders = window.CollectionListSliders || {};

  function initCollectionSlider(container) {
    const sectionId = container.dataset.sectionId;

    if (window.CollectionListSliders[sectionId]) {
      window.CollectionListSliders[sectionId].destroy();
    }

    window.CollectionListSliders[sectionId] = new CollectionListSlider(container);
  }

  function initAllCollectionSliders() {
    document.querySelectorAll(".collection-list-section").forEach(section => {
      requestAnimationFrame(() => initCollectionSlider(section));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllCollectionSliders);
  } else {
    initAllCollectionSliders();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      event.target.querySelectorAll(".collection-list-section").forEach(initCollectionSlider);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      const container = event.target.querySelector(".collection-list-section") ||
        (event.target.classList?.contains('collection-list-section') ? event.target : null);
      if (!container) return;

      const sectionId = container.dataset.sectionId;
      if (window.CollectionListSliders[sectionId]) {
        window.CollectionListSliders[sectionId].destroy();
        delete window.CollectionListSliders[sectionId];
      }
    });

    document.addEventListener("shopify:block:select", (event) => {
      const section = event.target.closest(".collection-list-section");
      if (section) initCollectionSlider(section);
    });
  }

})();

/* collection list js end */

/* visual story js start */

document.addEventListener("DOMContentLoaded", function () {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.reveal-node').forEach(el => observer.observe(el));
});

/* visual story js end */

/* media grid js start */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.scroll-down').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      const currentShopifySection = btn.closest('.shopify-section');
      if (!currentShopifySection) return;

      let nextShopifySection = currentShopifySection.nextElementSibling;

      while (
        nextShopifySection &&
        !nextShopifySection.classList.contains('shopify-section')
      ) {
        nextShopifySection = nextShopifySection.nextElementSibling;
      }

      if (!nextShopifySection) return;

      const headerOffset = document.querySelector('[data-sticky-header]')
        ? document.querySelector('[data-sticky-header]').offsetHeight
        : 0;

      const targetPosition =
        nextShopifySection.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });
});

/* media grid js end */

/* highlight testimonial slider js start */

(function () {

  function initHighlightTestimonialSection(container) {
    if (!container) return;
    const sliders = container.classList?.contains('highlight-testimonial-slider') ? [container] : container.querySelectorAll(".highlight-testimonial-slider");

    sliders.forEach(slider => {
      const desktopSlides = slider.dataset.desktopSlides || 2;
      const mobileSlides = slider.dataset.mobileSlides || 1;
      const autoplay = slider.dataset.autoplay === "true";

      Kinderly.Swiper.init(slider, {
        slidesPerView: desktopSlides,
        spaceBetween: 40,
        centeredSlides: true,
        loop: true,
        autoplay: autoplay ? { delay: 3000, disableOnInteraction: false } : false,
        navigation: {
          nextEl: slider.querySelector(".highlight-testimonial-next"),
          prevEl: slider.querySelector(".highlight-testimonial-prev"),
        },
        pagination: {
          el: slider.querySelector(".highlight-testimonial-pagination"),
          type: "progressbar",
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          450: { slidesPerView: mobileSlides, spaceBetween: 20 },
          767: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: desktopSlides, spaceBetween: 40 }
        }
      });
    });
  }

  function initAllHighlightTestimonials() {
    document.querySelectorAll(".highlight-testimonial-section").forEach(section => {
      requestAnimationFrame(() => initHighlightTestimonialSection(section));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllHighlightTestimonials);
  } else {
    initAllHighlightTestimonials();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      event.target.querySelectorAll(".highlight-testimonial-section").forEach(initHighlightTestimonialSection);
    });
    document.addEventListener("shopify:block:select", (event) => {
      const section = event.target.closest(".highlight-testimonial-section");
      if (section) initHighlightTestimonialSection(section);
    });
  }

})();

/* highlight testimonial slider js end */

/* featured look slideshow js start */

if (typeof Swiper !== 'undefined' && document.querySelector('.featured-look-slideshow')) {
  var swiper = new Swiper(".featured-look-slideshow", {
    navigation: {
      nextEl: ".featured-look-next",
      prevEl: ".featured-look-prev",
    },
  });
}

/* featured slideshow js end */

/* shop the look js start */

document.addEventListener('DOMContentLoaded', function () {
  const hotspotWrappers = document.querySelectorAll('.shop-the-look-hotspot-wrapper');
  let hoverTimeout;

  hotspotWrappers.forEach(wrapper => {
    const hotspot = wrapper.querySelector('.shop-the-look-hotspot');
    if (!hotspot) return;

    if (!['A', 'BUTTON'].includes(hotspot.tagName) && !hotspot.hasAttribute('tabindex')) {
      hotspot.setAttribute('tabindex', '0');
      hotspot.setAttribute('role', 'button');
    }

    function activateWrapper() {
      hotspotWrappers.forEach(w => {
        if (w !== wrapper) {
          w.classList.remove('active');
        }
      });
      wrapper.classList.add('active');
    }

    hotspot.addEventListener('click', function (e) {
      e.stopPropagation();
      activateWrapper();
    });

    hotspot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateWrapper();
      }
    });

    wrapper.addEventListener('mouseenter', function () {
      clearTimeout(hoverTimeout);
      activateWrapper();
    });

    wrapper.addEventListener('mouseleave', function () {
      hoverTimeout = setTimeout(() => {
        wrapper.classList.remove('active');
      }, 200);
    });

    const popup = wrapper.querySelector('.shop-the-look-popup');
    if (popup) {
      popup.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimeout);
      });

      popup.addEventListener('mouseleave', function () {
        hoverTimeout = setTimeout(() => {
          wrapper.classList.remove('active');
        }, 200);
      });

      popup.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  });

  document.addEventListener('click', function () {
    hotspotWrappers.forEach(w => w.classList.remove('active'));
  });
});

/* shop the look js end */

document.addEventListener('DOMContentLoaded', () => {
  initAnimatedHeadings();
});

function initAnimatedHeadings() {
  const headings = document.querySelectorAll('.sequence-text');

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateSequence(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.4
    }
  );

  headings.forEach(el => observer.observe(el));
}

function animateSequence(el) {
  let delay = 100;

  function toTitleCase(text) {
    return text.replace(/\b([a-z])/gi, char => char.toUpperCase());
  }

  function processNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = toTitleCase(node.textContent);
      const fragment = document.createDocumentFragment();

      for (let char of text) {
        if (char === ' ') {
          fragment.appendChild(document.createTextNode(' '));
        } else {
          const span = document.createElement('span');
          span.textContent = char;
          span.style.animationDelay = delay + 'ms';
          delay += 20;
          fragment.appendChild(span);
        }
      }

      node.replaceWith(fragment);
    }

    else if (node.nodeType === Node.ELEMENT_NODE) {
      [...node.childNodes].forEach(processNode);
    }
  }

  [...el.childNodes].forEach(processNode);
}

/* image zigzag js start */

function initImageZigzag() {
  const sections = document.querySelectorAll('.image-with-text-section');

  sections.forEach(section => {
    const blocks = section.querySelectorAll('.zigzag-animate-item');
    if (!blocks.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-animated');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    blocks.forEach(block => observer.observe(block));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initImageZigzag();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('image-with-text-section') || event.target.querySelector('.image-with-text-section')) {
      initImageZigzag();
      setTimeout(() => {
      }, 200);
    }
  });
}

/* image zigzag js end */

/* animated search placeholder (typewriter) js start */

(function () {

  const FALLBACK_SUGGESTIONS = [
    'Search for baby toys...',
    'Search for kids clothes...',
    'Search for school bags...',
    'Search for story books...',
    'Search for wooden blocks...',
    'Search for art supplies...',
    'Search for board games...',
    'Search for puzzles...',
  ];

  const TYPE_SPEED = 60;
  const ERASE_SPEED = 30;
  const PAUSE_AFTER = 1800;
  const PAUSE_BEFORE = 400;

  function getSuggestions() {
    const raw = window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.searchPlaceholderSuggestions;

    if (Array.isArray(raw) && raw.length > 0) {
      const cleaned = raw.map(s => s.trim()).filter(s => s.length > 0);
      if (cleaned.length > 0) return cleaned;
    }

    return FALLBACK_SUGGESTIONS;
  }

  function isAnimationEnabled() {
    const settings = window.themeVariables && window.themeVariables.settings;
    if (!settings || settings.searchPlaceholderAnimationEnabled === undefined) return true;
    return settings.searchPlaceholderAnimationEnabled === true;
  }

  let animState = {
    targets: [],
    suggestions: [],
    currentIndex: 0,
    charIndex: 0,
    isErasing: false,
    timer: null,
    active: false,
    originalPlaceholders: [],
  };

  function setPlaceholder(text) {
    animState.targets.forEach(input => {
      input.placeholder = text;
    });
  }

  function restorePlaceholders() {
    animState.targets.forEach((input, i) => {
      input.placeholder = animState.originalPlaceholders[i] || '';
    });
  }

  function isInputEmpty() {
    return animState.targets.every(input => input.value.trim() === '');
  }

  function tick() {
    if (!animState.active || !isInputEmpty()) return;

    const suggestions = animState.suggestions;
    if (!suggestions.length) return;

    const current = suggestions[animState.currentIndex % suggestions.length];

    if (!animState.isErasing) {
      animState.charIndex++;
      setPlaceholder(current.slice(0, animState.charIndex));

      if (animState.charIndex >= current.length) {
        animState.isErasing = true;
        animState.timer = setTimeout(tick, PAUSE_AFTER);
      } else {
        animState.timer = setTimeout(tick, TYPE_SPEED);
      }
    } else {
      animState.charIndex--;
      setPlaceholder(current.slice(0, animState.charIndex));

      if (animState.charIndex <= 0) {
        animState.isErasing = false;
        animState.currentIndex = (animState.currentIndex + 1) % suggestions.length;
        animState.timer = setTimeout(tick, PAUSE_BEFORE);
      } else {
        animState.timer = setTimeout(tick, ERASE_SPEED);
      }
    }
  }

  function startAnimation() {
    if (!isAnimationEnabled()) return;
    if (animState.active) return;
    if (!animState.targets.length) return;
    if (!animState.suggestions.length) return;
    if (!isInputEmpty()) return;

    animState.active = true;
    animState.charIndex = 0;
    animState.isErasing = false;
    clearTimeout(animState.timer);
    animState.timer = setTimeout(tick, PAUSE_BEFORE);
  }

  function stopAnimation() {
    animState.active = false;
    clearTimeout(animState.timer);
    restorePlaceholders();
  }

  function setup() {
    if (!isAnimationEnabled()) return;

    const searchOverlay = document.getElementById('search-overlay');
    if (!searchOverlay) return;
    animState.suggestions = getSuggestions();
    animState.targets = Array.from(document.querySelectorAll('.search-input'));
    if (!animState.targets.length) return;

    animState.originalPlaceholders = animState.targets.map(el => el.placeholder);
    animState.currentIndex = 0;
    if (searchOverlay._placeholderObserver) {
      searchOverlay._placeholderObserver.disconnect();
    }

    const observer = new MutationObserver(() => {
      if (searchOverlay.classList.contains('active')) {
        animState.suggestions = getSuggestions();
        animState.currentIndex = 0;
        setTimeout(startAnimation, 350);
      } else {
        stopAnimation();
        animState.targets = Array.from(document.querySelectorAll('.search-input'));
        animState.originalPlaceholders = animState.targets.map(el => el.placeholder);
      }
    });

    searchOverlay._placeholderObserver = observer;
    observer.observe(searchOverlay, { attributes: true, attributeFilter: ['class'] });

    if (!document._placeholderInputListenerAttached) {
      document._placeholderInputListenerAttached = true;

      document.addEventListener('input', e => {
        if (!animState.targets.includes(e.target)) return;

        if (e.target.value.trim().length > 0) {
          animState.active = false;
          clearTimeout(animState.timer);
          restorePlaceholders();
        } else {
          animState.charIndex = 0;
          animState.isErasing = false;
          startAnimation();
        }
      });
    }
  }

  const initSearch = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => initSearch());
  } else {
    setTimeout(initSearch, 300);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', setup);
  }

})();

/* animated search placeholder (typewriter) js end */

/* custom cursor js start */

(function () {

  function isTouchOnly() {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  function getCursorStyle() {
    return (window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.cursorStyle) || 'unset';
  }

  function initCursor() {
    if (isTouchOnly()) return;

    const style = getCursorStyle();
    if (style === 'unset') return;

    const cursor = document.getElementById('custom-cursor');
    const tpl = document.getElementById('custom-cursor-icon-tpl');
    if (!cursor || !tpl) return;

    cursor.innerHTML = tpl.innerHTML;
    document.body.classList.add('custom-cursor-active', `custom-cursor-${style}`);

    let firstMove = false;

    const cleanups = [];
    function addEvent(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(() => target.removeEventListener(type, handler, options));
    }

    addEvent(document, 'mousemove', (e) => {
      cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0) translate(-50%, -50%)`;

      if (!firstMove) {
        firstMove = true;
        cursor.style.opacity = '1';
      }
    }, { passive: true });

    addEvent(document, 'mouseleave', () => {
      cursor.style.opacity = '0';
    });

    addEvent(document, 'mouseenter', () => {
      if (firstMove) cursor.style.opacity = '1';
    });

    addEvent(document, 'mousedown', () => {
      cursor.classList.add('clicked');
    });

    addEvent(document, 'mouseup', () => {
      cursor.classList.remove('clicked');
    });

    const INTERACTIVE = 'a, button, [role="button"], label, .swatch, .color-swatch, .menu-item, input, textarea, select, [tabindex]:not([tabindex="-1"])';

    addEvent(document, 'mouseover', (e) => {
      if (e.target && e.target.closest && e.target.closest(INTERACTIVE)) {
        cursor.style.opacity = '0';
      }
    });

    addEvent(document, 'mouseout', (e) => {
      const related = e.relatedTarget;
      if (!related || !related.closest || !related.closest(INTERACTIVE)) {
        if (firstMove) cursor.style.opacity = '1';
      }
    });

    cursor._cleanups = cleanups;
  }

  function destroyCursor() {
    const cursor = document.getElementById('custom-cursor');
    if (cursor) {
      if (cursor._cleanups) {
        cursor._cleanups.forEach(cleanup => cleanup());
        cursor._cleanups = null;
      }
      cursor.innerHTML = '';
    }
    document.body.classList.remove(
      'custom-cursor-active',
      'custom-cursor-star',
      'custom-cursor-button',
      'custom-cursor-teddy'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCursor);
  } else {
    initCursor();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      destroyCursor();
      initCursor();
    });
  }

})();

/* custom cursor js end */

window.pauseAllMedia = function (except) {
  document.querySelectorAll('video').forEach((video) => {
    if (video === except) return;
    if (!video.paused) video.pause();
  });

  document.querySelectorAll('model-viewer').forEach((model) => {
    if (model === except) return;
    if (typeof model.pause === 'function') model.pause();
  });

  document.querySelectorAll('iframe').forEach((iframe) => {
    if (iframe === except) return;
    try {
      if (iframe.src.indexOf('youtube.com') !== -1) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
          '*'
        );
      } else if (iframe.src.indexOf('vimeo.com') !== -1) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ method: 'pause' }),
          '*'
        );
      }
    } catch (e) {
    }
  });
};